var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"form-inline"},[_c('button',{staticClass:"btn saved-gear",attrs:{"type":"button"},on:{"click":_vm.routeToProductSet}},[_vm._v("💾  My Gear")])])
}
var staticRenderFns = []

export { render, staticRenderFns }